import Headroom from 'headroom.js'
import barba from '@barba/core';
import barbaCss from '@barba/css';

const loading = document.getElementById('loading')
const loadingEls = document.querySelectorAll('.loading-el')
let barbaCtn = document.querySelector('#barba-wrapper')

barba.use(barbaCss);
barba.init({
    prefetchIgnore: true,
    timeout: 4000,
    preventRunning: true,
    transitions: [
        {
            beforeOnce(){
                setTimeout(() => {
                }, 0)
            },
            once(){},
            afterOnce(){
                setTimeout(() => {
                }, 2000)
            },
        },
    ]
})
barba.hooks.beforeLeave((data) => {
    loadingEls.forEach((loadingEl, key) => {
        let timing = parseInt(loadingEl.dataset.top) + 2
        setTimeout(() => {
            loadingEl.style.width = '19.5%'
            loadingEl.style.height = '100%'
            loadingEl.style.top = loadingEl.dataset.top + '%'
            loadingEl.style.left = loadingEl.dataset.left + '%'
            loadingEl.style.transform = 'scale(1)'
            loadingEl.style.visibility = "visible"
            loadingEl.style.opacity = "1"
            loadingEl.style.transition = `all 0.4s linear`
            // loadingEl.style.transition = `all 0.${timing}s linear`
            if(key < 5) {
                // loadingEl.style.transition = `all 0.3s linear`
            // loadingEl.style.transition = `all 0.${timing}s linear`
            }
        }, key)
    })
    setTimeout(() => {
        barbaCtn.style.opacity = '0'
    }, 1000)
    barbaCtn.style.opacity = '0'
}),

barba.hooks.enter(() => {
    window.scrollTo(0, 0);
})
barba.hooks.afterEnter((data) => {
    barbaCtn.style.opacity = '0'
    for(let i = loadingEls.length-1; i >= 0; i--) {
        let timing = parseInt(loadingEls[i].dataset.top) + 19
        setTimeout(() => {
            loadingEls[i].style.width = "19.5%"
            loadingEls[i].style.height = "-100%"
            loadingEls[i].style.opacity = "0"
            loadingEls[i].style.visibility = "hidden"
            loadingEls[i].style.top = loadingEls[i].dataset.top + '%'
            loadingEls[i].style.left = loadingEls[i].dataset.left +  '%'
            // loadingEls[i].style.transition = `all 0.29s linear`
            // loadingEls[i].style.transition = `all 0.${timing}s linear`
            loadingEls[i].style.transition = `all 0.4s linear`
            if(i >= 5) {
                // loadingEls[i].style.transition = `all 0.${timing}s linear`
            }
        }, 1000);
        setTimeout(() => {
            loadingEls[i].style.height = "0"
        }, 1400)
    }
    setTimeout(() => {
        barbaCtn.style.opacity = '1'
        document.body.style.opacity = '1'
    }, 1000)
    let hash = window.location.href.split('#')[1]
    let scrollEl = document.getElementById(hash)
    scrollEl.scrollIntoView()
}),
barba.hooks.after((data, next) => {
    let parser = new DOMParser();
    let htmlDoc = parser.parseFromString(data.next.html.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', data.next.html), 'text/html');
    let bodyClasses = htmlDoc.querySelector('notbody').getAttribute('class');
    document.body.setAttribute('class', bodyClasses);
    library.init();
})




let library = {
    'observer': function() {
        var opacityTargets = document.querySelectorAll('.is-opacity');
        let movingTargets = document.querySelectorAll('.is-move');
        let movingTargetsLtr = document.querySelectorAll('.is-move-ltr');
        let willBeFancy = document.querySelectorAll('.will-be-fancy');
        let willBeFancy2 = document.querySelectorAll('.will-be-fancy-2');
        let willBeTyped = document.querySelectorAll('.typed');

        let newTargets = [...opacityTargets, ...movingTargets, ...movingTargetsLtr];
        let animatedTargets = [...willBeFancy, ...willBeFancy2];
        let typingTargets = [...willBeTyped];

        const options = {
            root: null,
            rootMargin: '0px 20px 0px 30px',
            threshold: [0, 0.25, 0.75, 1]
        }
        
        observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if(entry.intersectionRatio > 0.5) {
                    entry.target.classList.add('fancy');
                    observer.unobserve(entry.target)
                }
            }) 
        }, options);

        observer2 = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                // const boundsRect = entry.boundingClientRect;
                if(entry.intersectionRatio > 0.5) {
                    // console.log(boundsRect.y)
                    entry.target.classList.add('fancy-dual-box');
                    observer.unobserve(entry.target)
                }
            })
        }, options);


        newTargets.forEach(myTarget => {
            observer.observe(myTarget)
        })
        animatedTargets.forEach(target => {
            observer2.observe(target)
        })

    },
    'swiper': function(bodyClass) {
        // if(document.body.classList.contains(bodyClass)) {
        //     let slideIndex = 0;
        //     let slides = document.getElementsByClassName("slider");
        //     if(slides !== null) {
        //         showSlides();
        //     }
        //     function showSlides() {
        //       let i;
        //       let slides = document.getElementsByClassName("slider");
        //       if(slides !== null) {
        //             let pages = document.querySelectorAll(".slider-controls li");
        //             let overlay = document.getElementById("overlay")
        //             for (i = 0; i < slides.length; i++) {
        //                 slides[i].classList.contains("slide-active") ? slides[slideIndex-1].classList.toggle("slide-active") : '';
        //                 pages[i].classList.contains("active") ? pages[slideIndex-1].classList.toggle("active") : '';
        //             }
        //             slideIndex++;
        //             if (slideIndex > slides.length) {slideIndex = 1}
        //             if(slides){
        //                 console.log(slides)
        //                 slides[slideIndex-1].classList.toggle("slide-active");
        //                 pages[slideIndex-1].classList.toggle("active");
        //                 setTimeout(showSlides, (slides.length*2000)); // Change image every 2 seconds
        //             }
        //         }
        //     }
        // }
    },
    'overlays': function() {
        let overlay1 = document.getElementById("overlay1")
        let overlay2 = document.getElementById("overlay2")
        let overlay3 = document.getElementById("overlay3")
        if(document.body.classList.contains('home')) {
            overlay1.style.width = '200%';
            overlay2.style.width = '200%';
            overlay3.style.width = '200%';
        }
    },
    'letters': function() {
        // let letters = document.querySelectorAll('.hero--text-wrap span')
        // let i
        // let timer = 800
        
        // letters.forEach(letter => {
        //     setTimeout(() => {
        //         letter.style.opacity = '1';
        //         letter.style.transform = 'scale(1)';
        //     },timer)
        //     timer+= 100
        // });
    },
    'headroom': function() {
        let myElement = document.querySelector("header");
        let headroom  = new Headroom(myElement);
        headroom.init()
    },
    'toTop': () => {
        const btn = document.getElementById("btnToTop");
        window.onscroll = function() {scrollFunction()};
        function scrollFunction() {
            if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
                if(btn !== null) {
                    btn.classList.remove("inactive");
                }
            } else {
                if(btn !== null) {
                    btn.classList.add("inactive");
                }
            }
        }
        function topFunction() {
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            }
            if(btn !== null) {
                btn.addEventListener("click", () => {
                        topFunction()
                })
            }
    },
    'navigation': function() {
        /***
         * PC MENU
         */
        if(window.innerWidth >= 769) {
            const hasMenuLink = document.querySelectorAll(".has-menu")
            console.log(hasMenuLink)
            if(hasMenuLink !== null) {
                hasMenuLink.forEach(link => {
                    window.addEventListener('click', (e) => {
                        if(e.target !== 'a') {
                            hasMenuLink.forEach(l => l.classList.remove('is-active-menu'))
                        }
                    } )
                    link.addEventListener('mouseover', (e) => {
                        hasMenuLink.forEach(l => 
                            l.classList.remove('is-active-menu')
                        )
                        link.classList.toggle('is-active-menu')
                        // let hasMenuUl = document.querySelectorAll('li.is-active-menu ul li a')
                        // hasMenuUl.forEach(a => {
                        //     a.addEventListener('mouseout', () => {
                        //         console.log(a.parentElement.parentElement.parentElement.classList.remove('is-active-menu'))
                        //     })
                        // })                        
                        link.parentElement.addEventListener('mouseleave', (e) => {
                            console.log(link)
                            console.log(hasMenuLink)
                            document.querySelectorAll(".is-active-menu ul").forEach(ul => {
                                ul.style.opacity = 0
                                setTimeout(() => {
                                    ul.removeAttribute('style')
                                    link.classList.remove('is-active-menu')
                                }, 900)
                            })
                            // link.classList.toggle('is-active-menu')
                        })
                    })

                })
            }
        }

        /***
         * SP HAMBURGER MENU
        */
       if(window.innerWidth < 769) {
           const hamburger = document.querySelector('.hamburger')
           const secondaryLinks = document.querySelectorAll('a.second')
           if(hamburger !== null) {
               const hasMenuLink = document.querySelectorAll(".has-menu > a:first-of-type")  
               const activeMenuLinks = document.querySelectorAll(".is-active-menu + ul a")  
               hamburger.addEventListener('click', (e) => {
                   document.querySelector('#barba-wrapper').classList.toggle('nav-is-active')
               })
               hasMenuLink.forEach(link => {
                    link.addEventListener('click', () => {
                        link.parentElement.classList.toggle('is-active-menu')
                    })
               })
               activeMenuLinks.forEach(link => {
                link.addEventListener('click', () => {
                    link.parentElement.parentElement.toggle('is-active-menu')
                })
               })
               secondaryLinks.forEach(link => {
                    link.addEventListener('click', () => {
                        document.querySelector('#barba-wrapper').classList.toggle('nav-is-active')
                    })
               })
            }
        }


        /***
         * SP Navigation panel
         */
        const subMenu = document.querySelector(".menu-sub");
        if(subMenu !== null) {
            subMenu.addEventListener("click", function() {
                document.body.classList.toggle('menu-is-open')
                const panel = document.querySelector(".submenu");
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }

    },
    'accordion': function() {
        if(window.innerWidth <= 600) {
            const firsts = document.querySelectorAll('li.first')
            firsts.forEach(el => {
                Array.from(el.parentNode.children).forEach(li => {
                    if(! li.classList.contains('first')) {
                        li.style.maxHeight = 0;
                        li.style.borderTop = "none";
                    }
                })
                el.addEventListener('click', (e) => {
                    el.classList.toggle('active')
                    Array.from(el.parentNode.children).forEach(li => {
                        if(! li.classList.contains('first')) {
                            if(el.classList.contains('active')) {
                                li.style.maxHeight = '55px';
                                li.style.borderTop = "1px solid #707070";
                            }
                            else {
                                li.style.maxHeight = 0;
                                li.style.borderTop = "none";
                            }
                        }
                    })
                })
            })
        }
    },
    'homepage': function() {
        console.log('test homepage')
        this.observer()
        this.overlays()
        // this.letters()
        this.headroom()
        this.toTop()
        this.navigation()
        this.accordion()
        this.swiper('home')
        // this.accordionNavSp()
    },
    'page': function() {
        console.log('test page')
        this.navigation()
        this.headroom()
        this.toTop()
        this.observer()
        this.accordion()
    },
    'init': function() {
        console.log('test init')
        if (!document.body.classList.contains('page-id-5')) {
            console.log('test init 7')
            this.page()
        }
        if (document.body.classList.contains('home')) {
            console.log('test init 4')
            this.homepage()
        } 
    }
}



// if (document.body.classList.contains('home')) {
    library.init()
    console.log('First init')
// }